/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedsendinvoicedaysinadvance5Inputs */

const en__field_inheritedsendinvoicedaysinadvance5 = /** @type {(inputs: _Field_Inheritedsendinvoicedaysinadvance5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`invoices are going to be sent x days in advance (inherited)`)
};

const de__field_inheritedsendinvoicedaysinadvance5 = /** @type {(inputs: _Field_Inheritedsendinvoicedaysinadvance5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungen werden X Tage vor Beginn gesendet (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "invoices are going to be sent x days in advance (inherited)" |
*
* @param {_Field_Inheritedsendinvoicedaysinadvance5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedsendinvoicedaysinadvance5 = /** @type {((inputs?: _Field_Inheritedsendinvoicedaysinadvance5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedsendinvoicedaysinadvance5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedsendinvoicedaysinadvance5(inputs)
	return de__field_inheritedsendinvoicedaysinadvance5(inputs)
});
export { _field_inheritedsendinvoicedaysinadvance5 as "_field_inheritedSendInvoiceDaysInAdvance" }